import { logos } from 'common'
import { css } from 'styled-components'

export const defaultDarkVars = css`
  :root {
    --button-background: transparent;
    --button-color: rgba(255, 255, 255, 1);
    --wallet-dropdown-width: auto;

    --hamburger-color: rgba(255, 255, 255, 1);
    --hamburger-arrow-position-right: 15px;
    --wallet-color: rgba(255, 255, 255, 1);

    /********************
    // NEW theme colors //
    *********************/
    --site-primary-color: #2159d1;
    --site-result-won-color: hsl(126, 100%, 38%);
    --site-result-lost-color: hsl(340, 88%, 46%);
    --site-result-unknown-color: rgba(255, 255, 255, 0.3);
    --site-background: linear-gradient(180deg, #252934, #222630, #1f232c, #1d2028, #1a1d24, #171a20, #15171d, #121419);

    //buttons
    --primary-button-background: linear-gradient(
      180deg,
      #2159d1,
      #1f56c9,
      #1e52c0,
      #1c4fb8,
      #1b4baf,
      #1a48a7,
      #19449f,
      #184197
    );
    --primary-button-border: #1d4fb9;
    --primary-button-hover-background: hsl(221, 73%, 47%);
    --primary-text-color: rgba(255, 255, 255, 1);
    --primary-active: rgba(29, 75, 175, 1);
    --primary-shadow: hsl(221, 73%, 47%);

    --side-panel-background: hsla(0, 0%, 100%, 0.1);

    //details
    --summary-color: #2159d1;
    --summary-background-color: hsla(0, 0%, 0%, 0.3);
    --summary-background-color-hover: hsl(213, 19%, 5%);
    --summary-bg-color-open: #1a1a1f;
    --summary-bg-color-close: linear-gradient(
      180deg,
      #2c2d35,
      #2b2c34,
      #2a2b33,
      #292a32,
      #282930,
      #27282f,
      #26272e,
      #25262d
    );
    --summary-bg-color-hover: hsl(213, 19%, 5%);

    --input-background: hsl(218, 23%, 25%);
    --input-border: rgba(42, 109, 255, 0.5);

    --dropdown-header-background: hsla(0, 0%, 100%, 0.2);
    --overlay-pad-background: hsla(0, 0%, 40%, 0.1);
    --chat-message-pad-background: hsla(0, 0%, 100%, 0.07);
    --box-shadow-color: rgba(0, 0, 0, 0.4);
    --modal-pad-background: hsla(0, 0%, 100%, 0.05);

    --bidding-table-tab-selected-background: hsl(215, 18%, 8%);

    //AssetDropdown
    --asset-dropdown-background: hsla(218, 17%, 12%, 1);

    //dropdown
    --dropdown-background: rgba(255, 255, 255, 0.2);
    --dropdown-backdrop-filter: blur(40px);
    --dropdown-color: rgba(255, 255, 255, 1);
    --dropdown-width: 370px;

    //links
    --link-underline-color: hsla(0, 0%, 100%, 0.5);

    // toggle
    --toggle-switch-background: #ffffff;
    --toggle-switch-border: none;

    --toggle-body-border: 1px solid transparent;
    --toggle-body-background: hsla(0, 0%, 100%, 0.2);

    --toggle-active-body-border: #2159d1;
    --toggle-active-body-background: #2159d1;

    //Tabs
    --tab-text-color: rgba(255, 255, 255, 0.35);
    --tab-section-background: hsla(214, 18%, 25%, 0.3);

    --tab-hover-background: rgba(255, 255, 255, 0.05);
    --tab-hover-text-color: #b3cbff;
    --tab-hover-text-shadow: rgba(42, 109, 255, 1);

    //Left panel
    --panel-profile-background: #393d47;

    //Table transparent
    --transparent_table-header-background: hsla(0, 0%, 0%, 0.4);
    --transparent_table-data-background: hsla(0, 0%, 100%, 0.1);
    --transparent_table-data-border-color: hsla(0, 0%, 100%, 0.2);

    //Bidding Table
    --bidding-table-background: hsl(216, 11%, 16%);
    --bidding-table-header-background: hsl(216, 11%, 16%);
    --bidding-table-tab-selected-background: hsla(0, 0%, 100%, 0.1);
    --bidding-table-tab-selected-text-shadow: 0 0 10px rgba(42, 109, 255, 1);
    --bidding-table-tab-selected-text-color: hsl(0, 0%, 100%);
    --bidding-table-cell-border: hsla(0, 0%, 100%, 0.1);

    //Tabs bar
    --tab-bar-border: hsla(0, 0%, 100%, 0.1);
    --tab-bar-background: hsla(0, 0%, 0%, 0.1);
    --tab-bar-color: hsla(0, 0%, 100%, 0.5);
    --tab-bar-active-border: hsla(221, 73%, 47%, 0.7);
    --tab-bar-active-background: hsl(221, 73%, 47%);
    --tab-bar-active-color: hsl(0, 0%, 100%);

    //Share card
    --share-card-background: #161616;
    /*********************************
    // LOGOS and other images files //
    ********************************/
    --main-logo: url(${logos.yolorekt_logo_stacked});
    --main-logo-margin-top: 50px;
    --lvg-graph-container-margin-top: 0px;
  }
`
